import { TimelineMax } from 'gsap';

export default ({
    container,
    texts,
    count,
    countTween,
    onTextStart,
    onTextComplete,
}) => {
    const timeline = new TimelineMax();

    timeline.fromTo(container, 1, {
        autoAlpha: 0,
    }, {
        autoAlpha: 1,
    });

    const textsKeys = Object.keys(texts);
    const textsCount = textsKeys.length;
    textsKeys.forEach((key, index) => {
        const textTimeline = new TimelineMax();
        const isLast = (textsCount - 1) === index;
        textTimeline.fromTo(texts[key], 1, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            onStart: () => {
                onTextStart(key);
            },
            onComplete: () => {
                if (isLast) {
                    onTextComplete(key);
                }
            },
        });
        if (index === 0) {
            textTimeline.fromTo(count, 1, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 0);
        }
        if (key === 'connecting') {
            textTimeline.add(countTween, 0);
        }
        if (!isLast) {
            textTimeline.to(texts[key], 0.2, {
                autoAlpha: 0,
                onComplete: () => {
                    onTextComplete(key);
                },
            }, key === 'connecting' ? '+=1' : `+=${index === 0 ? 5 : 3}`);
        }

        timeline.add(textTimeline);
    });


    return timeline;
};



// WEBPACK FOOTER //
// ./animations/statsFadeIn.js